import React from "react";
import { Row, Col, Modal, ModalBody, ModalFooter, Label } from "reactstrap";
import styles from "./ViewFileModal.module.css";
import FileViewer from 'react-file-viewer';


export const ViewFileModal = ({ 
    isOpen, 
    toggle, 
    centered, 
    selectedDoc 
}) => {
    const isPdf = selectedDoc?.documentName?.substring(selectedDoc?.documentName?.lastIndexOf(".") + 1) === 'pdf' ? true : false;

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            modalClassName="viewDocModal"
            contentClassName="viewDocModalContent"
            centered={centered}
            size="lg"
        >
            <div className={styles.viewDocModalHeader}>
                <h4 className={'mb-0'} id="exampleModalLongTitle">
                    {selectedDoc?.documentName}
                </h4>
            </div>
            <ModalBody className={styles.viewDocModalBody}>
                <Row className='justify-content-center'>
                    <Col 
                        md="8"
                        className={
                            isPdf
                                ? styles.pdfViewer
                                : styles.docImage
                        }
                    >
                        {isPdf ? (
                            <FileViewer
                                fileType="pdf"
                                filePath={`data:application/pdf;base64,${selectedDoc?.documentData}`}
                                className={styles.pdfImage}
                            />
                        ) : (
                            <input
                                type="image"
                                src={`data:image/png;base64,${selectedDoc?.documentData}`}
                            />
                        )}
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <button className="btn-primary" onClick={toggle}>
                    Close
                </button>
            </ModalFooter>
        </Modal>
    );
};
